module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/de/julia-42b16e837692cc23eadf9ada8adbd4fe.jpg";